import React, {useEffect, useState} from "react";
import {Box, Fade, Typography} from "@mui/material";
import styled from "styled-components/macro";
import TableHead from "./components/TableHead";
import {
  fetchPropertyAccessibilityInfo,
  fetchPropertyFreeTextInfos
} from "../../../../../../../../redux/actions/propertyActions";
import {useDispatch} from "react-redux";
import {useSelector} from "../../../../../../../../redux/store";
import {useParams} from "react-router-dom";
import TableInformationByDisabilityRow from "./components/TableInformationByDisabilityRow";
import TableSkeleton from "./components/TableSkeleton";
import InfoCard from "../../../../../../../../components/InfoCard";
import {useTranslation} from "react-i18next";
import NoHaveData from "../../../../NoHaveData";
import EditFreeTexts from "./components/edit-free-texts/EditFreeTexts";
import {fetchQuestions} from "../../../../../../../../redux/actions/questionsActions";
import {Question} from "../../../../../../../../models/Question";
import {AppStateType} from "../../../../../../../../redux/reducers";
import {questionSets} from "./questionList";

const TableWrapper = styled.div`
  overflow-x: auto;
  table {
    border-left: 1px;
    border-right: 1px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.05);
  }
`

const PracticalInformationTab = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const params: {id: string} = useParams()
  const user = useSelector((state) => state.authReducer.user);
  const questions = useSelector((state) => state.questionsReducer.questions);
  const propertyAccessibilityInfo = useSelector((state) => state.propertyReducer.propertyAccessibilityInfo)
  const [questionsByStandard, setQuestionsByStandard] = useState<Question[] | null>(null)
  const property = useSelector((state: AppStateType) => state.propertyReducer.property)!
  const propertyFreeTextInfos = useSelector((state) => state.propertyReducer.propertyFreeTextInfos)

  useEffect(() => {
    if (questions.length === 0) {
      dispatch(fetchQuestions(user!.token))
    }
    if (!propertyFreeTextInfos) {
      dispatch(fetchPropertyFreeTextInfos(user!.token, params.id))
    }
    if (!propertyAccessibilityInfo) {
      dispatch(fetchPropertyAccessibilityInfo(user!.token, params.id))
    }
  }, []);

  useEffect(() => {
    if (questions.length > 0 && property && property.a11y_standard) {
      const setQuestions = questionSets[property.a11y_standard]
      if (setQuestions && setQuestions.length > 0) {
        const mappedQuestions = questions.filter((q) => setQuestions.includes(q.id))
        setQuestionsByStandard(mappedQuestions)
      } else {
        setQuestionsByStandard([])
      }
    }
  }, [questions, property]);


  return (
    <Box>
      <Fade in={true}>
        <div>
          <InfoCard title={t('we_are_showing_followings') + ':'}>
            <Typography fontSize={14}>{t('we_are_recommended_to_state')}</Typography>
          </InfoCard>
            <TableWrapper>
              {questionsByStandard ? (
                questionsByStandard.length > 0 ? (
                  <table style={{minWidth: '800px', width: '100%'}}>
                    <TableHead items={['select_what_you_want_to_show', 'displayed_in_widget', '']}/>
                    <tbody>
                    {questionsByStandard.map((q) => (
                      <TableInformationByDisabilityRow
                        question={q}
                        propertyAccessibilityInfo={propertyAccessibilityInfo}
                      />
                    ))}
                    </tbody>
                  </table>
                ) : (
                  <Box mb={2}>
                    <NoHaveData
                      show={true}
                      content={t('statsPage_noDataAvailable_topText')}
                    />
                  </Box>
                )
              ) : (
                <Box mb={2}>
                  <TableSkeleton />
                </Box>
              )}
              <Box mt={3}>
                <EditFreeTexts />
              </Box>
            </TableWrapper>
        </div>
      </Fade>
    </Box>
  )
}

export default PracticalInformationTab